<template>
	<div id="newsDetail">
		<div class="topLan1">
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link class="box1" :to="{path: 'index'}">首页</router-link>
				<router-link class="box1" :to="{name: 'platform'}">电商平台</router-link>
				<router-link class="box1" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link class="box1" :to="{name: 'about'}">关于我们</router-link>
				<router-link class="box1" :to="{name: 'newsCenter'}">新闻中心
					<div class="boxLine1"></div>
				</router-link>
				<router-link class="box1" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link class="box1" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" class="box1">首页</a>
				<a href="platform" class="box1">电商平台</a>
				<a href="canvass" class="box1">招商入驻</a>
				<a href="about" class="box1">关于我们</a>
				<a href="newsCenter" class="box1">新闻中心
					<div class="boxLine1"></div>
				</a>
				<a href="recruit" class="box1">人才招聘</a>
				<a href="downLoad" class="box1">下载APP</a> -->
			</div>
		</div>
		
		
		<div class="newsDetailArea">
			<div class="details">
				<div class="detailTitle">{{newsForm.title}}</div>
				<div class="detailTime">{{newsForm.yearMonthDay}}</div>
				<div class="detailLine"></div>
				<!-- <div></div> -->
				<div class="ql-container ">
					<p class="ql-editor" v-html="newsForm.content"></p>
				</div>
				<div class="mianze">免责声明：本网站内容来自作者投稿或互联网转载，目的在于传递更多信息，不代表本网赞同其观点或证实其内容的真实性。文章内容及配图如有侵权或对文章观点有异议，请联系我们处理。如转载本网站文章，务必保留本网注明的稿件来源，并自行承担法律责任。联系电话：400-688-6999</div>
			</div>
			<img class="detailRightPic" src="../../static/pic/img_chatu_news@2x.png"/>
		</div>
		
		<bottom-area></bottom-area>
	</div>
</template>

<script>
	import {newsDetail} from "../../api/news.js"
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				content:"<p class=\"ql-align-center\">爱山东高速单号哦奥USB到速必达</p><p>\t\t阿斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的</p><p class=\"ql-align-center\"><img src=\"http://image.hudiejx.com/help/20210809/fcd0468c01144a8d8c9a5b9f36936709.png\"></p><p>阿斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的阿斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的阿斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的斯顿钙塑不低啊u不是嗲USB带上吧阿斯顿把奥白色的</p>",
				newsId:null,
				newsForm:{}
				
			}
		},
		created() {
			this.newsId = this.$route.params.id
			this.getNewsDetail(this.newsId)
			document.documentElement.scrollTop = 0
		},
		mounted() {
		},
		methods: {
			getNewsDetail(id){
				newsDetail(id).then(res => {
					this.newsForm = res.data
				}).catch(err => {
					console.log(err)
				})
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#newsDetail {
		width: 100%;
		height: 100%;
		text-align: left;
	}
	
	.newsDetailArea{
		width: 100%;
		margin-top: 222px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		/* align-items: center; */
	}
	.details{
		float: left;
		width: 860px;
		display: flex;
		flex-direction: column;
	}
	.detailRightPic{
		float: right;
		width: 320px;
		height: 588px;
	}
	.detailTitle{
		width: 100%;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #467CFD;
	}
	.detailTime{
		width: 100%;
		margin-top: 13px;
		height: 12px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #6A7599;
	}
	.detailLine{
		margin-top: 26px;
		width: 100%;
		height: 1px;
		background: #D8D8D8;
	}
	.detailInfo{
		width: 100%;
		margin-top: 50px;
	}
	.mianze{
		width: 100%;
		margin-top: 40px;
		margin-bottom: 40px;
		font-size: 14px;
		color: #999;
	}
</style>
